import { BANK_TRANSFER } from "../../shared/constants";

// 振込先(DESIGN.md §2)。承認後の請求・チャージ案内で共通利用。
export function BankBox() {
  return (
    <div className="bank-box">
      <dl>
        <dt>銀行名</dt>
        <dd>
          {BANK_TRANSFER.bankName}（金融機関コード {BANK_TRANSFER.bankCode}）
        </dd>
        <dt>支店</dt>
        <dd>
          {BANK_TRANSFER.branchName}（店番 {BANK_TRANSFER.branchCode}）
        </dd>
        <dt>口座種別</dt>
        <dd>{BANK_TRANSFER.accountType}</dd>
        <dt>口座番号</dt>
        <dd>{BANK_TRANSFER.accountNumber}</dd>
        <dt>口座名義</dt>
        <dd>{BANK_TRANSFER.accountHolder}</dd>
      </dl>
    </div>
  );
}
